import { TripPayment } from "../trips/trip.payment";
import { ClientBalanceReport } from "./client.balance.report";
import { Vehicle } from "../vehicles/vehicle";

export class DataSummary{
    dailyTripCount: number = 0;
    dailyTripCurrentYearCount: number = 0;
    dailyTripPreviousYearCount: number = 0;

    vehicleWithNoTrips: Vehicle[] = [];
    date: string; 
    clientBalances: ClientBalanceReport[] = [];
    checksDue: TripPayment[] = [];
}


// WEBPACK FOOTER //
// ./src/app/models/reports/dataSummary.ts